<div class="tunnel-page-container">
  <div class="card-marketing-container funding">
    <ng-casto-card-marketing [imageSrc]="placeholderImageSrc">
      <!-- <ng-template #headerTemplate>
      </ng-template> -->
      <ng-template #bodyTemplate>
        <div [innerHtml]="'funding.marketing_' + this.context | translate"></div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="buttons">
          <ng-casto-button class="secondary borderless" label="En savoir +" (click)="more()"></ng-casto-button>
        </div>
      </ng-template>
    </ng-casto-card-marketing>
  </div>
  <div class="body-container">
    <ng-container #fundingContainer></ng-container>
  </div>
  <div class="action-bar-container">
    <ng-casto-action-bar></ng-casto-action-bar>
  </div>
</div>
